import { AriaAttributes, AriaRole, ReactNode } from 'react';

import { ButtonBase } from '@mui/material';

interface WrapperProps extends AriaAttributes {
  id?: string;
  className?: string;
  children?: ReactNode;
  onClick?: React.MouseEventHandler;
  tabIndex?: number;
  role?: AriaRole;
}

const Wrapper = ({ id, className, children, onClick, tabIndex, ...props }: WrapperProps) => {
  if (onClick) {
    return (
      <ButtonBase id={id} focusRipple className={className} onClick={onClick} tabIndex={tabIndex} {...props}>
        {children}
      </ButtonBase>
    );
  }

  return (
    <div id={id} className={className} tabIndex={tabIndex} {...props}>
      {children}
    </div>
  );
};

export default Wrapper;
